<template>
  <div class="page-content-wrapper">
    <div class="content">
      <div class="container-fluid container-fixed-lg">
        <div class="row p-3">
          <div class="col-lg-12">
            <h2 class="text-dag">{{ $t('profile_change_pwd') }}</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6 m-b-10">
            <div class="card no-border widget-loader-circle no-padding rounded">

              <div v-if="!passwordChanged"
                   class="card-body p-t-25 p-b-30">
                <form>
                  <div class="form-group contact">
                    <label for="oldpassword">
                      <p class="adviestitle">{{ $t('profile_current_pwd') }}:</p>
                    </label>
                    <b-form-input type="password"
                                  class="form-control form-control-lg"
                                  id="oldpassword"
                                  :placeholder="$t('profile_current_pwd')"
                                  v-model="changeData.CurrentPassword">
                    </b-form-input>
                  </div>
                  <div class="form-group contact">
                    <label for="newpassword">
                      <p class="adviestitle">{{ $t('profile_new_pwd') }}:</p>
                    </label>
                    <b-form-input type="password"
                                  class="form-control form-control-lg"
                                  :class="{'form-control-not-valid': errors.has('newpassword')}"
                                  v-validate="'required|min:8|confirmed:confirmpassword'"
                                  name="newpassword"
                                  id="newpassword"
                                  :placeholder="$t('profile_new_pwd')"
                                  v-model="changeData.NewPassword">
                    </b-form-input>
                    <small class="form-text text-danger" v-if="errors.has('newpassword')">
                      {{ errors.first('newpassword') }}
                    </small>
                  </div>
                  <div class="form-group contact">
                    <label for="confirmpassword">
                      <p class="adviestitle">{{ $t('profile_confirm_pwd') }}:</p>
                    </label>
                    <b-form-input type="password"
                                  class="form-control form-control-lg"
                                  :class="{'form-control-not-valid': errors.has('confirmpassword')}"
                                  v-validate="'required|min:8'"
                                  ref="confirmpassword"
                                  name="confirmpassword"
                                  id="confirmpassword"
                                  :placeholder="$t('profile_confirm_pwd')"
                                  v-model="changeData.ConfirmNewPassword">
                    </b-form-input>
                    <small class="form-text text-danger" v-if="errors.has('confirmpassword')">
                      {{ errors.first('confirmpassword') }}
                    </small>
                  </div>
                </form>
                <button class="advicebutton text-white confirm"
                        @click="submitChange">
                  {{ $t('profile_send') }}
                </button>
              </div>

              <div v-else
                   class="card-body p-t-25 p-b-30">
                {{ $t('profile_set_success') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    methods: {
      ...mapActions([
        'userChangePassword',
      ]),
      submitChange () {
        if (this.changeData.NewPassword != '') {
          this.userChangePassword(this.changeData).then(response => {
            console.log(response)
            this.passwordChanged = true
          }, error => {
            console.error(error)
          })
        } else {
          console.error('Confirm password did not matched')
        }
      }
    },
    data() {
      return {
        passwordChanged: false,
        changeData: {
          CurrentPassword: '',
          NewPassword: '',
          ConfirmNewPassword: '',
        }
      }
    },
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/profile/ChangePassword.vue